import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {brandColor, greenColor, orangeColor, redColor, rgba} from "~/theme";
import UIIcon from "~/old-ui/UIIcon";
import UIContainer from "~/old-ui/UIContainer";

export default function UINotificationBar({success, warning, danger, closable, onClose, container: Container, className, children, ...props}) {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, {
      [classes.success]: success,
      [classes.warning]: warning,
      [classes.danger]: danger,
    }, className)} {...props}>
      <Container className={classes.container}>{children}</Container>

      {closable && (
        <UIIcon
          tabIndex={0}
          className={classes.closeIcon}
          name='fa-times'
          onClick={onClose}
        />
      )}
    </div>
  );
}

UINotificationBar.defaultProps = {
  container: UIContainer,
};

const useStyles = createUseStyles({
  root: {
    position: 'relative',
    padding: [[4, 0, 6]],

    backgroundColor: rgba(brandColor, .90),
    color: '#fff',

    '& + &': {
      borderTop: [[1, 'solid', rgba('#fff', .3)]],
      marginTop: -1,
    }
  },

  success: {
    backgroundColor: rgba(greenColor, .75),
    color: '#fff',
  },

  danger: {
    backgroundColor: rgba(redColor, .75),
    color: '#fff',
  },

  warning: {
    backgroundColor: rgba(orangeColor, .75),
    color: '#fff',
  },

  closeIcon: {
    cursor: 'pointer',
    outline: 'none',
    color: rgba('#fff', .75),

    '&:hover': {
      color: '#fff',
    },

    position: 'absolute',
    right: 16,
    top: 6,

    width: 14,
    height: 14,
  },

  container: {
    textAlign: 'center',
  }
});
